import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import { toast, ToastContainer } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditSales from "./AddEditSales";
import ViewSales from "./ViewSales";
import AddEditBackOrder from "./AddEditBackOrder";
import AddNewSales from "./AddNewSales";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxesPacking,
  faCar,
  faCircleExclamation,
  faFileInvoice,
  faLock,
  faScrewdriverWrench,
  faSpinner,
  faUser,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import Recommendation from "../Recommendation/Recommendation";
import AddEditSalesMain from "./AddEditSalesMain";

import ChargeInclusion from "../Administrator/ChargeInclusion";

const Charges = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);

  const [showPreloader, setPreloader] = useState("normal");
  const [strTransactions, setTransactions] = useState("");
  const [selRow, setSelectedRow] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = (message) => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();
    notify(message);
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(
      props.apiServer + "/transactionslist?parentcode=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function ShowDeleted() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("deleted");
    loadData();
  }

  function ShowReturns() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("returns");
    loadData();
  }

  function ShowSales() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("sales");
    loadData();
  }

  function ShowAll() {
    setPreloader("normal");
    setTransactions("");
    loadData();
  }
  const useMountEffect = (functionName) => useEffect(functionName, []);

  // useMountEffect(checkAdminAccess);
  // useMountEffect(loadData);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [strTransactions]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [props.code]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [props.parentcode]);

  const TitleBar = () => {
    return (
      <h6
        style={{ fontFamily: "Montserrat", fontWeight: "400" }}
        className="display-5 blue-grey-text ml-1"
      >
        {" "}
        Summary of Charges
      </h6>
    );
  };

  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <MDBRow>
              <MDBCol md="4"></MDBCol>
              <MDBCol md="4" className="text-center">
                <br />
                <img
                  src={props.deployURL + "/loading.gif"}
                  style={{ width: "300px", textAlign: "center" }}
                  alt="loading"
                />
                <br />
              </MDBCol>
              <MDBCol md="4"></MDBCol>
            </MDBRow>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="12">
                  <MDBCard>
                    <MDBCardHeader className="cloudy-knoxville-gradient">
                      <span
                        className="h5-responsive blue-text"
                        style={{
                          fontFamily: "Montserrat",
                          fontWeight: "400",
                        }}
                      >
                        <span className="blue-text">
                          <FontAwesomeIcon icon={faFileInvoice} />
                        </span>
                        &nbsp;Summary of Charges
                      </span>
                    </MDBCardHeader>

                    <MaterialTable
                      title=""
                      columns={[
                        {
                          title: "Date/Time",
                          field: "transactiondatetextsales",
                          type: "datetime",
                          hidden: true,
                        },
                        {
                          title: "Item",
                          field: "item",

                          render: (rowData) => (
                            <>
                              <span className="font-weight-bold">
                                <strong>{rowData.item}</strong>
                              </span>{" "}
                              <br />
                              <span className="small">
                                {rowData.transactiontype == "BACK ORDER" ? (
                                  <span className="font-weight-bold red-text">
                                    {rowData.ChargeType}{" "}
                                    <small>({rowData.transactiontype})</small>
                                  </span>
                                ) : (
                                  <span className="black-text">
                                    {rowData.ChargeType}
                                  </span>
                                )}
                              </span>
                              <br />
                              <span className="small">
                                {rowData.transactiondatetextsales}
                              </span>
                            </>
                          ),
                          width: "70%",
                        },

                        { title: "code", field: "code", hidden: true },

                        { title: "Price", field: "price" },

                        // { title: "ItemCode", field: "itemcode" },
                        // { title: "PackageCode", field: "packagecode" },

                        { title: "Qty", field: "quantity" },

                        { title: "Total Price", field: "totalprice" },
                        {
                          title: "Charge Type",
                          field: "ChargeType",
                          hidden: false,
                          defaultGroupOrder: 0,
                        },
                      ]}
                      data={rows}
                      options={{
                        search: true,
                        actionsColumnIndex: -1,
                        pageSize: 10,
                        pageSizeOptions: [
                          { value: rows.length, label: "All" },
                          10,
                          25,
                          50,
                          100,
                        ],
                        detailPanelType: "single",
                        grouping: true,
                      }}
                    />
                  </MDBCard>
                </MDBCol>
              </MDBRow>
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      {/* <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={2000}
      /> */}
      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default Charges;
